import React from "react";
import { Row, Col, ProgressBar, Form } from "react-bootstrap";
import PropTypes from "prop-types";
import useLogger from "../../util/Logger";
import "./WorkOrderWorkItemProgress.css";

function WorkOrderWorkItemProgress({ workItem }) {
  const logger = useLogger();

  const statusMap = [
    { status: "Active", displayName: "Active", progress: 0 },
    { status: "Unassigned", displayName: "Pending Assignment", progress: 0 },
    { status: "Assigned", displayName: "", progress: 33 },
    { status: "Accepted", displayName: "", progress: 33 },
    { status: "TravellingTo", displayName: "", progress: 66 },
    { status: "PreWorking", displayName: "Pre-work", progress: 66 },
    { status: "Working", displayName: "Working", progress: 100 },
    { status: "Post Working", displayName: "", progress: 100 },
    { status: "Travelling From", displayName: "", progress: 100 },
    { status: "No Access Forms", displayName: "", progress: 100 },
    { status: "No Access", displayName: "", progress: 100 },
    { status: "Rejected", displayName: "Rejected", progress: 100 },
    { status: "Reject Forms", displayName: "", progress: 100 },
    { status: "Closed", displayName: "Closed", progress: 100 },
    { status: "Completed", displayName: "Completed", progress: 100 },
    { status: "Cancelled", displayName: "Cancelled", progress: 100 },
  ];

  const progress = () => {
    logger.debug(
      "WorkOrderWorkItemProgress.progress",
      `Calculating progress for workItem '${workItem?.id}'`
    );

    let progressCount = 0;

    const statusMatches = statusMap.filter(
      (item) => item.status === workItem.currentWorkflowStageType
    );

    if (statusMatches.length === 1) {
      progressCount = statusMatches[0].progress;
    }

    logger.debug(
      "WorkOrderWorkItemProgress.progress",
      `Progress for workItem '${workItem?.id}' calculated as '${progress}'`
    );

    return progressCount;
  };

  const view = (
    <Row>
      <Col>
        <Row>
          <Col xs={3} className="progress-bar-label-container-first">
            <Form.Label>Pending Assignment</Form.Label>
          </Col>
          <Col xs={3} className="progress-bar-label">
            <Form.Label className="progress-bar-label-33">Assigned</Form.Label>
          </Col>
          <Col xs={3} className="progress-bar-label-container">
            <Form.Label className="progress-bar-label-66">
              Travelling
            </Form.Label>
          </Col>
          <Col xs={3} className="progress-bar-label-container-last">
            <Form.Label>Working</Form.Label>
          </Col>
        </Row>
        <Row>
          <Col>
            <ProgressBar now={progress()} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
  return view;
}

WorkOrderWorkItemProgress.propTypes = {
  workItem: PropTypes.shape({
    id: PropTypes.string,
    currentWorkflowStageType: PropTypes.string,
  }).isRequired,
};

export default WorkOrderWorkItemProgress;
